import {Params} from '@feathersjs/feathers'

import {PrintingMethod} from '../../types'

import * as feathersService from '../feathers'

export const PRINTING_METHOD = 'printingMethod'

export const get = async (params?: Params) =>
  feathersService.find<PrintingMethod>(PRINTING_METHOD, params)
